import { Injectable } from '@angular/core';

// campfire
import { TpaHandoverService, LoggerService } from '@campfire-nx/api';

export interface ITpaHandoverPayload {
  policy_uuid: string;
  for_cover: string;
}

@Injectable({
  providedIn: 'root'
})
export class TpaService {
  constructor(
    private tpaHandoverService: TpaHandoverService,
    private loggerService: LoggerService
  ) {}

  handoverToTpa(payload: ITpaHandoverPayload): Promise<any> {
    return this.tpaHandoverService.tpaHandover(payload)
      .then((response: any) => response)
      .catch((err) => {
        this.loggerService.error('UserDataService', 'getLatestUserData', { error: err });
      });
  }
}
